import { styled } from '@mui/material';

import { RouterLink } from '.';

export const SidebarLogo = styled(RouterLink)({
  display: 'flex',
  justifyContent: 'center',
  cursor: 'pointer',
});
